import { collection, addDoc, onSnapshot, query, orderBy, limit, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../../firebase';
import { getSpecialtyCollection, getSpecialtyStorageFolder } from 'util/specialtyCollections';

// Generate unique batch ID
export const generateBatchId = () => {
  const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const rand = Math.random().toString(36).slice(2, 6);
  return `BATCH-${date}-${rand}`;
};

// Upload file to Firebase Storage, return { storagePath, downloadUrl }
// storagePath: uploads/{folder}/{batchId}/{fileName}
// Returns null values if upload fails (non-blocking)
export const uploadBatchFile = async (file, folder, batchId, specialty = 'pmr') => {
  try {
    const prefixedFolder = getSpecialtyStorageFolder(folder, specialty);
    const storagePath = `uploads/${prefixedFolder}/${batchId}/${file.name}`;
    const storageRef = ref(storage, storagePath);
    await uploadBytes(storageRef, file);
    const downloadUrl = await getDownloadURL(storageRef);
    return { storagePath, downloadUrl };
  } catch (err) {
    console.error('Batch file upload failed:', err);
    return { storagePath: null, downloadUrl: null };
  }
};

// Save a log entry to Firestore
// folder: 'bulk_upload' | 'bulk_edit' | 'full_length'
export const saveUploadLog = (folder, logData) => async (dispatch, getState) => {
  try {
    const logsRef = collection(db, getSpecialtyCollection('questionBankUploadLogs', getState), folder, 'entries');
    await addDoc(logsRef, {
      ...logData,
      uploadedAt: serverTimestamp(),
    });
  } catch (err) {
    console.error('Failed to save upload log:', err);
  }
};

// Subscribe to logs for a folder (real-time, latest 20)
// Returns an unsubscribe function — call it on component unmount
export const FETCH_UPLOAD_LOGS_REQUEST = 'FETCH_UPLOAD_LOGS_REQUEST';
export const FETCH_UPLOAD_LOGS_SUCCESS = 'FETCH_UPLOAD_LOGS_SUCCESS';
export const FETCH_UPLOAD_LOGS_FAILURE = 'FETCH_UPLOAD_LOGS_FAILURE';

export const subscribeUploadLogs = (folder) => (dispatch, getState) => {
  dispatch({ type: FETCH_UPLOAD_LOGS_REQUEST, folder });
  const logsRef = collection(db, getSpecialtyCollection('questionBankUploadLogs', getState), folder, 'entries');
  const q = query(logsRef, orderBy('uploadedAt', 'desc'), limit(20));

  const unsubscribe = onSnapshot(
    q,
    (snapshot) => {
      const logs = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        uploadedAt: doc.data().uploadedAt?.toDate?.()?.toISOString() || null,
      }));
      dispatch({ type: FETCH_UPLOAD_LOGS_SUCCESS, folder, payload: logs });
    },
    (err) => {
      dispatch({ type: FETCH_UPLOAD_LOGS_FAILURE, folder, error: err.message });
    }
  );

  return unsubscribe;
};
